// src/components/login/index.js
import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";

const AUTH_ERRORS = {
  no_permission: "You do not have permissions for this application.",
  stale_session:
    "Your sign-in session is out of date. Please sign out of your Microsoft account completely and sign back in.",
  login_failed: "Sign-in failed. Please try again.",
};

// The server sends the user back with ?auth_error=<code> when a sign-in can't
// be completed.
const getAuthError = () => {
  const code = new URLSearchParams(window.location.search).get("auth_error");
  return AUTH_ERRORS[code] || null;
};

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      submitted: false,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { username } = this.state;

    // Validate username
    if (!username) {
      return;
    }

    // Set loading state
    this.setState({ loading: true });

    // Set flag to indicate login is in progress
    sessionStorage.setItem("logging_in", "true");

    axios
      .post(`${process.env.REACT_APP_BIGHORN_SERVER}/api/methodLogin`, {
        domain: username.split("@")[1],
      })
      .then((result) => {
        console.log(result.data.type);
        let type = result.data.type;

        // Call auth login
        this.props.auth.login(username, type);

        // Note: Don't clear the flag here - it will be cleared in auth.js
        // after successful authentication
      })
      .catch((err) => {
        console.log(err);

        // Clear the logging_in flag on error
        sessionStorage.removeItem("logging_in");

        // Reset loading state
        this.setState({ loading: false });

        toast.error("There was a problem logging you in. Please check your user id and try again");
      });
  }

  render() {
    const { username, submitted, loading } = this.state;
    const authError = getAuthError();

    return (
      <div>
        {authError && (
          <div className="help-block" role="alert" style={{ color: "#c0392b", marginBottom: "10px" }}>
            {authError}
          </div>
        )}
        <form name="form" onSubmit={this.handleSubmit}>
          <div className={"form-group" + (submitted && !username ? " has-error" : "")}>
            <label htmlFor="username" style={{ fontWeight: 500, fontSize: "18px" }}>
              Username
            </label>
            <input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={this.handleChange}
              disabled={loading}
              placeholder="Enter your email address"
            />
            {submitted && !username && <div className="help-block">Username is required</div>}
          </div>
          <div className="form-group">
            <button
              id="login-button"
              style={{ background: "rgba(0, 126, 167, 1)", marginTop: "10px" }}
              className="btn btn-primary"
              disabled={loading}>
              {loading ? "Logging in..." : "Log In"}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
